/**
 * Parse semver-like x.y.z for version header comparison.
 * @param {string} version
 * @returns {[number, number, number] | null}
 */
const parseVersionParts = (version) => {
  const match = String(version || "")
    .trim()
    .match(/^(\d+)\.(\d+)\.(\d+)/);
  if (!match) return null;
  return [Number(match[1]), Number(match[2]), Number(match[3])];
};

/**
 * True when the API build is strictly newer than the web app (x-version header).
 * Ignores missing/unknown/non-semver values so AWS beta without CLIENT_VERSION
 * does not force reload loops in local dev.
 * @param {string | null | undefined} serverVersion
 * @param {string | null | undefined} clientVersion
 * @returns {boolean}
 */
export const isServerVersionNewer = (serverVersion, clientVersion) => {
  const server = parseVersionParts(serverVersion);
  const client = parseVersionParts(clientVersion);
  if (!server || !client) return false;

  for (let i = 0; i < 3; i += 1) {
    if (server[i] > client[i]) return true;
    if (server[i] < client[i]) return false;
  }
  return false;
};
